import { useCallback, useEffect, useRef } from 'react'
/**
 * hooks helper to determine if the click is a double click.
 * @param clickInterval - interval between click
 * @returns function to evalue if the the click is a double click
 */
function useIsDoubleClick(clickInterval = 400) {
  const clickCounterRef = useRef<Record<string, number>>({})
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const clickTimer = useRef<any>()
  const isDoubleClick = useCallback(
    (key: string) => {
      if (clickCounterRef.current[key] === undefined) {
        clickCounterRef.current[key] = 0
      }
      const clickCount = ++clickCounterRef.current[key]
      if (clickCount === 1) {
        clickTimer.current = setTimeout(function () {
          clickCounterRef.current[key] = 0
        }, clickInterval)
      } else if (clickCount === 2) {
        clickTimer.current && clearTimeout(clickTimer.current)
        clickCounterRef.current[key] = 0
        return true
      }
      return false
    },
    [clickInterval]
  )
  useEffect(() => {
    return () => {
      clickTimer.current && clearTimeout(clickTimer.current)
    }
  }, [])
  return isDoubleClick
}

export default useIsDoubleClick
